module.exports = __webpack_public_path__ + "static/media/flamp.426674b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/flamp.svg
// module id = 900
// module chunks = 0